import {Theme} from '../../theme/Theme';

const {colours} = Theme;

export enum OwnershipStatus {
  EXPIRED = 'Expired',
  OWNED = 'Owned',
  CANCELLED = 'Cancelled',
  SUBSCRIBED = 'Monthly payments',
  PURCHASED = 'Purchased',
  LOADING = 'Loading',
  NONE = 'None',
}

interface OwnershipCardSettings {
  button?: {
    copy: string;
    colour: string;
    background: string;
  };
  info?: {
    termRemainingCopy?: string;
    statusCopy: string;
  };
}

export const cardSettings: Map<OwnershipStatus, OwnershipCardSettings> =
  new Map<OwnershipStatus, OwnershipCardSettings>([
    [
      OwnershipStatus.CANCELLED,
      {
        button: {
          copy: 'Reactivate monthly payments',
          background: colours.yellow,
          colour: colours.greys[7],
        },
        info: {
          statusCopy: 'Monthly payments cancelled',
          termRemainingCopy: 'Expires at the end of the month',
        },
      },
    ],
    [
      OwnershipStatus.EXPIRED,
      {
        button: {
          copy: 'Start monthly payments',
          background: colours.blue,
          colour: colours.white,
        },
        info: {statusCopy: 'Monthly payments expired', termRemainingCopy: ''},
      },
    ],
    [
      OwnershipStatus.SUBSCRIBED,
      {
        button: {
          copy: 'Cancel monthly payments',
          background: colours.red,
          colour: colours.white,
        },
        info: {
          statusCopy: 'Owned via Rent-to-own',
          termRemainingCopy: '$MONTHS payments until ownership',
        },
      },
    ],
    [
      OwnershipStatus.PURCHASED,
      {
        info: {
          statusCopy: 'Monthly payments complete',
          termRemainingCopy: 'No further payments',
        },
      },
    ],
    [
      OwnershipStatus.OWNED,
      {
        info: {
          statusCopy: 'One-time purchase',
          termRemainingCopy: 'No further payments',
        },
      },
    ],
  ]);

interface ProductMarketing {
  marketingCopy: string;
  purchaseButtonCopy: string;
}

export const productMarketing: Map<string, ProductMarketing> = new Map<
  string,
  ProductMarketing
>([
  [
    'com.focusrite.fast-equaliser',
    {
      marketingCopy: 'FAST Equaliser: Sculpt your sounds, effortlessly.',
      purchaseButtonCopy: 'Show me FAST Equaliser',
    },
  ],
  [
    'com.focusrite.fast-reveal',
    {
      marketingCopy: 'FAST Reveal: Give your sounds space, effortlessly.',
      purchaseButtonCopy: 'Show me FAST Reveal',
    },
  ],
  [
    'com.focusrite.fast-compressor',
    {
      marketingCopy: 'FAST Compressor: Perfect your mix, effortlessly.',
      purchaseButtonCopy: 'Show me FAST Compressor',
    },
  ],
  [
    'com.focusrite.fast-verb',
    {
      marketingCopy: 'FAST Verb: Add depth to your sound, effortlessly.',
      purchaseButtonCopy: 'Show me FAST Verb',
    },
  ],
  [
    'com.focusrite.fast-limiter',
    {
      marketingCopy: 'FAST Limiter',
      purchaseButtonCopy: 'Show me FAST Limiter',
    },
  ],
  [
    'com.focusrite.fast-balancer',
    {
      marketingCopy: 'FAST Balancer: Set the tone, effortlessly',
      purchaseButtonCopy: 'Show me FAST Balancer',
    },
  ],
]);
